import ActionCreator from "../../actionCreator";

export default {
    getSyncDetails: ActionCreator("GET_SYNC_DETAILS"),
    updateSyncDetails: ActionCreator("UPDATE_SYNC_DETAILS"),
    errorResponse: ActionCreator("ERROR_RESPONSE_SYNC_CALENDAR"),
};
